export default Object.freeze({
  Banco: 1,
  ACH: 2,
});
